var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myMenu",attrs:{"id":"myMenu"}},[_c('ul',_vm._l((_vm.val),function(item){return _c('li',{key:item,class:_vm.activeClass == item ? 'active':'',on:{"mouseover":function($event){return _vm.mouseover($event,item)}}},[_c('router-link',{attrs:{"to":""}},[_vm._t(item)],2)],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4b0a1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyMenu.vue
// module id = null
// module chunks = 